import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
    getInventoryHistoryDetailsApi,
    exportInventoryHistoryDetailsApi
} from "../../../services/manage-product/inventoryService";

export const fetchInventoryHistoryDetails = createAsyncThunk(
    'inventoryHistoryDetails/fetch',
    async (params, { rejectWithValue }) => {
        try {
            const response = await getInventoryHistoryDetailsApi(params);
            return response.response;
        } catch (e) {
            return rejectWithValue(typeof e === 'string' ? e : (e?.message || 'Failed to load inventory history.'));
        }
    }
);

export const exportInventoryHistoryDetails = createAsyncThunk(
    'inventoryHistoryDetails/export',
    async (params) => {
        const response = await exportInventoryHistoryDetailsApi(params);
        return response.response;
    }
);

const inventoryHistoryDetailsSlice = createSlice({
    name: 'inventoryHistoryDetails',
    initialState: {
        data: [],
        pagination: { page: 1, per_page: 25, count: 1, total: 0, page_total: 0 },
        filters: { sku: '', type: '', from: null, to: null, product_variant_id: null },
        loading: false,
        error: null,
    },
    reducers: {
        setInventoryHistoryDetailsFilters: (state, action) => {
            state.filters = action.payload;
        },
        setInventoryHistoryDetailsPage: (state, action) => {
            state.pagination.page = action.payload;
        },
        setInventoryHistoryDetailsPerPage: (state, action) => {
            state.pagination.per_page = action.payload;
            state.pagination.page = 1;
        },
        resetInventoryHistoryDetailsFilters: (state) => {
            state.filters = { sku: '', type: '', from: null, to: null, product_variant_id: null };
            state.pagination.page = 1;
        },
    },
    extraReducers: {
        [fetchInventoryHistoryDetails.pending]: (state) => {
            state.loading = true;
            state.error = null;
        },
        [fetchInventoryHistoryDetails.fulfilled]: (state, action) => {
            state.loading = false;
            state.data = action.payload.data;
            state.pagination = { ...state.pagination, ...action.payload.pagination };
        },
        [fetchInventoryHistoryDetails.rejected]: (state, action) => {
            state.loading = false;
            state.error = action.payload || 'Failed to load inventory history.';
        },
    },
});

export const {
    setInventoryHistoryDetailsFilters,
    setInventoryHistoryDetailsPage,
    setInventoryHistoryDetailsPerPage,
    resetInventoryHistoryDetailsFilters,
} = inventoryHistoryDetailsSlice.actions;

export default inventoryHistoryDetailsSlice.reducer;
